/**
 * RESPONSIBILITY: one photograph in the /adc gallery.
 */
import type { ImageValue } from '@framework/core';
import { Row, Text, Img } from '@framework/core/decorators';

@Row()
export class AdcPictureRow {
  @Img({ label: 'Picture', folder: 'adc', maxSizeMb: 12, size: '1200 × 800' })
  image!: ImageValue;

  @Text({ label: 'Caption', maxLength: 300 })
  caption!: string;
}
